import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { GlobalModule } from '@app/_global/global.module';
import { HTMLEditorModule } from '@app/components/html-editor';
import { TableModule } from '@app/primeng-overrides/table';
import { EventManagerService, IEventListener } from '@global/event-manager.service';
import { DividerModule } from 'primeng/divider';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PanelModule } from 'primeng/panel';
import { StatutRecolementSelectorModule } from '../statut-recolement-selector';
import { Article, Texte } from '../texte.model';
import { NomenclaturePipe } from '@app/nomenclature/nomenclature.pipe';

import { environment } from '@environments/environment';
import { normalizeStringForSearch, uid } from '@helpers/utils';
import { Rubrique } from '@app/nomenclature/nomenclature.model';


@Component({
	selector: 'readonly-article-dialog',
	templateUrl: './readonly-texte-dialog.html'
})
export class ReadonlyTextDialogComponent implements OnInit, IEventListener {

	private _uuid: string = uid();
	get uuid(): string { return this._uuid; }

	texte: Texte;

	articles: Article[] = [];
	expandedArticles: Record<number, boolean> = {};
	search: string | null;
	initialRowsPerPage: number = environment.default_rows;
	currentRowsPerPage: number = this.initialRowsPerPage;

	filteredArticlesCache: {search?: string, articles: Article[]} = {search: '', articles: []}


	constructor(
		private config: DynamicDialogConfig,
		private dialogRef: DynamicDialogRef,
		private eventManager: EventManagerService,
		private nomenclaturePipe: NomenclaturePipe
	) {
		this.texte = config.data.texte;
		
	}

	ngOnInit(): void {
		this.eventManager.registerEvent('close-modals', this, (args: any) => {
			this.dialogRef.close();
		});

		// On agrandit tous les articles courts par défaut et on arrange les art_ordre
		this.texte.articles.forEach((article: Article, index: number) => {
			if (article.art_corps && article.art_corps.length < 100) {
				this.expandedArticles[article.art_id] = true;
			}
			article.art_ordre = index;

			//@ts-ignore
			article.pristine = structuredClone(article);
		});

		// On agrandit forcément le premier article si il est seul
		if (this.texte.articles.length == 1) {
			this.expandedArticles[this.texte.articles[0].art_id] = true;
		}

		// On trie les rubriques par ordre alphabétique sur leur nom entier
		this.texte.rubriques = this.texte.rubriques.sort((rubA: Rubrique, rubB: Rubrique) =>  {
			let nomenclatureA = this.nomenclaturePipe.transform(rubA);
			let nomenclatureB = this.nomenclaturePipe.transform(rubB);
			return nomenclatureA < nomenclatureB ? - 1 : 1;
		});

		this.texte = structuredClone(this.texte);
		this.articles = [...this.texte.articles]
	}

	ngOnDestroy(): void {
		this.eventManager.unregisterEvent('close-modals', this);
	}

	onArticleSearchChange() {
		this.articles = [...this.texte.articles];
		let search = this.search;
		if (search && search?.trim() != '') {
			search = search.trim();
				const regex = new RegExp(normalizeStringForSearch(search)!, 'i');

				this.articles = this.articles.filter((article: Article) => {
				let normalizedTitle = normalizeStringForSearch(article.art_titre ?? '');
				let normalizedBodyPlaintext = normalizeStringForSearch(article.art_corps_plaintext ?? '');

				return normalizedTitle.match(regex) || normalizedBodyPlaintext.match(regex);
			});
		}
	}
	
}


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		GlobalModule,
		TableModule,
		StatutRecolementSelectorModule,
		HTMLEditorModule,
		DividerModule,
		PanelModule
	],
	exports: [ReadonlyTextDialogComponent],
	declarations: [ReadonlyTextDialogComponent]
})
export class ReadonlyTextDialogModule { }
